export const BxFileArchiveSolid = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <path
        d="M6 2C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2H11V4H9V6H11V8H9V10H11V18H7V12H9V10H7V8H9V6H7V4H9V2H6ZM13 4L18 9H13V4Z"
        fill="#686868"
      />
      <path d="M8 15H10V17H8V15Z" fill="#686868" />
    </svg>
  )
}
